import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import { FeatureFlippingManagerService } from '@sc/feature-flipping';
import { IconComponent } from '../icon';

@Component({
  selector: 'sc-phone-cta',
  styleUrls: ['./phone-cta.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, IconComponent],
  template: `
    <a
      class="phone-cta-container"
      tabindex="0"
      [class.disabled]="isDisabled"
      (click)="makeCall()"
      (keydown.enter)="makeCall()"
      (keydown.space)="makeCall()"
      *ngIf="isPhoneCtaActive() && phoneNumber"
      [attr.data-testid]="'phone-cta'"
    >
      <p class="phone-primary-container">
        <sc-icon name="phone" [specificName]="leftIconSpecificName"></sc-icon>
        <span class="sc-design-button">{{ getLabel() }}</span>
      </p>
      <p *ngIf="secondaryLabel" class="phone-secondary-container">
        <span class="sc-design-text-4">{{ secondaryLabel }}</span>
      </p>
    </a>
  `,
})
export class PhoneCtaComponent implements OnInit {
  @Input() phoneNumber: string;
  @Input() customLabel: string;
  @Input() secondaryLabel: string;
  @Input() customMakeCall = false;
  @Input() leftIconSpecificName: string = undefined;
  @Input() shouldSendCallEvent = false;
  @Input() isDisabled = false;
  @Output() customCallEvent = new EventEmitter<void>();
  constructor(
    private readonly configurationService: ConfigurationService,
    private readonly featureFlippingManagerService: FeatureFlippingManagerService
  ) {}

  ngOnInit(): void {
    if (this.isPhoneCtaActive() && !this.phoneNumber) {
      this.phoneNumber = this.configurationService.getConfig()?.phone;
    }
  }

  isPhoneCtaActive() {
    return this.featureFlippingManagerService.isFeatureActivated(
      'b2c-can-make-call-navbar'
    );
  }

  getLabel() {
    return this.customLabel ?? this.phoneNumber;
  }

  makeCall() {
    if (!this.customMakeCall) {
      window.location.href = 'tel:' + this.phoneNumber;
      if (this.shouldSendCallEvent) {
        this.customCallEvent.emit();
      }
    } else {
      this.customCallEvent.emit();
    }
  }
}
